export const CollaborationActions = {
    GET_COLLABORATION: "GET_COLLABORATION",
    SET_COLLABORATION: "SET_COLLABORATION",
  };